(function($) {
  var _body = document.getElementsByTagName("BODY")[0];
  var y = 0;
  var d = 0;
  var o = 100;

  window.addEventListener('scroll', event => {
    var scroll = window.scrollY || window.pageYOffset;

    if (y < scroll) {
      _body.classList.remove('scroll-up');
      _body.classList.add('scroll-down');
      d = scroll;
    } else if (d - o > scroll) {
      _body.classList.remove('scroll-down');
      _body.classList.add('scroll-up');
    }

    y = scroll;
  });
})(jQuery);